import * as Sentry from '@sentry/browser'
import { readResponseJson, getResponseDebugContext } from '@/util/api/response-body'
import { getAuth } from 'firebase/auth'
import { kPaxtonAppApiRESTBaseUrl } from '@/constants/constants-links'
import { ApiError } from '@/util/errors/api-error'

/** Remember a table explicitly opened in an accessible conversation. */
export async function putTableChat(tableId: string, conversationId: string, signal?: AbortSignal): Promise<void> {
  const token = await getAuth().currentUser?.getIdToken()
  if (!token) throw new Error('Sign in to access tables.')
  const url = `${kPaxtonAppApiRESTBaseUrl()}/api/v1/tables/${tableId}/chats/${conversationId}`
  const response = await fetch(url, {
    method: 'PUT',
    headers: { Authorization: `Bearer ${token}` },
    signal,
  })
  if (response.ok) return
  const { data } = await readResponseJson(response)
  const detail = data && typeof data === 'object' && 'detail' in data ? data.detail : undefined
  if (response.status >= 500) Sentry.captureException(new Error('Table chat link request failed'), { extra: getResponseDebugContext(response, url) })
  throw new ApiError(
    response.status,
    response.status >= 400 && response.status < 500 && typeof detail === 'string'
      ? detail
      : 'Unable to link this table to the chat. Reopen the table to retry.',
    response.status < 500 ? detail : undefined
  )
}
